import HiredWorkerCard from "./HiredWorkerCard";

export default HiredWorkerCard;
